module.exports = __webpack_public_path__ + "img/icon_solucoesTecnologia3.c257ad26.jpg";